// src/components/games/edit/GameEditTag.js
import React from 'react';

export default function GameEditTag({ tags = [] }) {
  // 문자열이면 콤마로 split → 배열로 변환
  const list = Array.isArray(tags)
    ? tags
    : typeof tags === 'string'
      ? tags.split(',').map(s => s.trim()).filter(Boolean)
      : [];

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-2">태그</h4>
      <div className="flex flex-wrap gap-2">
        {list.length > 0 ? (
          list.map((tag, idx) => (
            <span
              key={idx}
              className="text-sm text-gray-300 px-3 py-1 border border-gray-600 rounded-full"
            >
              #{tag}
            </span>
          ))
        ) : (
          <span className="text-gray-500">태그 없음</span>
        )}
      </div>
    </div>
  );
}
